import React, { useEffect } from "react"
import Popup from "./Popup"
import '../App.css';
import { useState,useReducer} from "react";
import Button from "./Button"
import Dropdown from "./Dropdown";
import EditText from "./EditText"
import Table1 from "./Table1";
import NewClient from "./NewClient";
import {reducer, initialState} from '../reducers/reducers'
import Searchbar from "./Searchbar";
import Container from "./Container";
import SearchClient from "./SearchClient";
import API_URLS from "../Urls";
import DropdownSearch from "./DropdownSearch";
import { useAuth } from "./AuthProvider";

const NewClaimTicket =({onClose, onAccept})=>{
    const { canWrite, canRead } = useAuth();
    const [state, dispatch] = useReducer(reducer, initialState);
    const [client, setClient] = useState(0)
    const [drone,setDrone] = useState({custom_product_name:"",cantidad:1,no_serie:"",causa:"",observaciones:"",tipo:"Dron Comercial",extra:0})
    const [battery,setBattery] = useState(false)
    const [control,setControl] =useState(false)
    const [propellers,setPropellers] = useState(false)
    const [extraItems,setExtraItems] = useState([])
    
    // Asegurarse de que solo los usuarios con permisos de escritura puedan crear notas
    useEffect(() => {
        if (!canWrite('acceso_notas_recepcion')) {
            onClose(); // Cerrar el popup si el usuario no tiene permisos
        }
    }, [canWrite, onClose]);
    
    const today = new Date()
    const [fetchedData,setFetchedData] = useState({
        Drones:[],
        Accesories:[],
        Parts:[]
    })
    const formattedDate = today.toISOString().split('T')[0];
    const [claimTicketData, setClaimTicketData] = useState({reparadoAntes:'No',cliente:0,tipo:'Comercial',fecha:formattedDate,facturar:'No',observaciones:"",sucursal:"Zacatecas"})
    
    useEffect(()=>{console.log(extraItems)},[extraItems])

    const postData = (url, dataToSend, onSuccesful) => {
        // Verificar si el usuario tiene permisos de escritura
        if (!canWrite('acceso_notas_recepcion')) {
            console.error('No tienes permisos para crear datos');
            alert('No tienes permisos para crear datos');
            return Promise.reject('No tienes permisos para crear datos');
        }
        
        console.log("Posting to URL:", url); // Check URL during each post
        console.log("Data to send:", dataToSend);

        return fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(dataToSend)
        })
        .then(response => {
            if (!response.ok) throw new Error('Network response was not ok ' + response.statusText);
            return response.json();
        })
        .then(data => {
            if (typeof onSuccesful === 'function') onSuccesful(data);
            console.log(data);
            return data;
        })
        .catch(error => {
            console.error('There was a problem with the fetch operation:', error);
            throw error;
        });
    };
    const fetchData = (url,setData) =>{
        // Verificar si el usuario tiene permisos de lectura
        if (!canRead('acceso_notas_recepcion')) {
            console.error('No tienes permisos para ver estos datos');
            alert('No tienes permisos para ver estos datos');
            return Promise.reject('No tienes permisos para ver estos datos');
        }
        
        return fetch(url, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          })
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Network response was not ok ' + response.statusText);
                }
                return response.json();
            })
            .then((data) => {
              console.log(data)
              setData(data)
              return data;
            })
            .catch((error) => {
              console.error("There was a problem with the fetch operation:", error);
              throw error;
            });
    }
    const prepareBatteryData = () => {
        if (battery === false) return [];
        
        // Crear un array con tantos elementos como baterías haya
        return Array(battery.cantidad).fill().map((_, index) => ({
          tipo: 'Accesorio',
          subtipo: 'Bateria',
          objectid: battery.objectid,
          no_serie: battery.series?.[index] || '', // Usar el número de serie correspondiente
          observaciones: battery.observaciones,
          cantidad: 1, // Cada batería es un registro individual
          extra: 0,
          custom_product_name: battery.custom_product_name || ''
        }));
      };
      const prepareControlData = () => {
        if (control === false) return [];
        
        return Array(control.cantidad).fill().map((_, index) => ({
          tipo: 'Accesorio',
          subtipo: 'Control',
          objectid: control.objectid,
          no_serie: control.series?.[index] || '',
          observaciones: control.observaciones,
          cantidad: 1, // Cada control es un registro individual
          extra: 0,
          custom_product_name: control.custom_product_name || ''
        }));
      };
      const generateFolio = (clientId, fechaNota, sucursal) => {
        let fechaFormateada = "000000";
        let id_sucursal = "NR";
        if (fechaNota) {
          const parts = fechaNota.split('-');
          if (parts.length === 3) {
            const [year, day, month] = parts;
            fechaFormateada = `${month}${day}${year}`;
          }
        }
        id_sucursal = sucursal === 'Aguascalientes' ? 'CA' : 'CZ';
        console.log("Generando folio con clientId:", clientId, "tipo:", typeof clientId);
        // Asegurarse de que clientId sea un string
        const clientIdStr = String(clientId || "");
        // Agregar minutos al final del folio para diferenciar folios creados el mismo día
        const minutos = new Date().getMinutes().toString().padStart(2, '0');
        return `${id_sucursal}${clientIdStr}${fechaFormateada}${minutos}`;
      };

      const downloadNotePDF = async (id, fecha, clienteID, sucursal) => {
        console.log("downloadNotePDF - clienteID:", clienteID, "tipo:", typeof clienteID);
        const folio = generateFolio(clienteID, fecha, sucursal);
        console.log("Folio generado:", folio);
        try {
          const response = await fetch(`${API_URLS.PRINT_NOTA}?id=${id}`);
          const blob = await response.blob();
          const url = window.URL.createObjectURL(new Blob([blob], {type: 'application/pdf'}));
          const a = document.createElement('a');
          a.href = url;
          a.download = `${folio}.pdf`;
          document.body.appendChild(a);
          a.click();
          a.remove();
          window.URL.revokeObjectURL(url);
        } catch (error) {
          console.error('Error al descargar el PDF:', error);
        }
      };
    useEffect(() => {
  fetchData(API_URLS.DRONES, (data) =>
    setFetchedData(prev => ({ ...prev, Drones: data }))
  );
  fetchData(API_URLS.ACCESORIES, (data) =>
    setFetchedData(prev => ({ ...prev, Accesories: data }))
  );
  fetchData(API_URLS.PARTS, (data) =>
    setFetchedData(prev => ({ ...prev, Parts: data }))
  );
}, []);
    return (
        <Popup  title="Nueva nota de recepcion" onClose={onClose}>
            <div className="item-container">
                <div className="invisible-horizontal-container">
                    <div style={{fontWeight:'bold'}}>Fecha:</div>
                    <div>{formattedDate}</div>
                </div>
                
                <div className="invisible-horizontal-container">
                    <div style={{fontWeight:'bold', minWidth: '80px'}}>Línea:</div>
                    <Dropdown returnSelectedOption={(option)=>{setClaimTicketData({...claimTicketData,tipo:option});setDrone({...drone,tipo:'Dron '+option})}} options={['Comercial', 'Enterprise']}></Dropdown>
                    
                    <div style={{fontWeight:'bold', minWidth: '80px'}}>Facturar?:</div>
                    <Dropdown returnSelectedOption={(option)=>{setClaimTicketData({...claimTicketData,facturar:option})}} options={['No','Si']}></Dropdown>
                    
                    <div style={{fontWeight:'bold', minWidth: '80px'}}>Sucursal:</div>
                    <Dropdown returnSelectedOption={(option)=>{setClaimTicketData({...claimTicketData,sucursal:option})}} options={['Zacatecas','Aguascalientes']}></Dropdown>
                </div>
                
                <div className="invisible-horizontal-container">
                    <div style={{fontWeight:'bold', minWidth: '150px'}}>Causa del incidente:</div>
                    <EditText onChange={(data)=>{setClaimTicketData({...claimTicketData,causa:data})}} text="Causa de incidente"></EditText>
                </div>
                
                <div className="invisible-horizontal-container">
                    <div style={{fontWeight:'bold', minWidth: '150px'}}>Observaciones generales:</div>
                    <EditText onChange={(data)=>{setClaimTicketData({...claimTicketData,observaciones:data})}} text="Observaciones generales"></EditText>
                </div>
            </div>

            <SearchClient onDeselected={()=>{setClaimTicketData({...claimTicketData,cliente:0})}} onSelected={(data)=>{setClaimTicketData({...claimTicketData,cliente:data.id})}}></SearchClient>
            
            <div className="header1">Dron</div>
            
            {fetchedData.Drones.length > 0 ? (
                <div className="item-container">
                    <div className="invisible-horizontal-container">
                        <div style={{fontWeight:'bold', minWidth: '150px'}}>Serie:</div>
                        <DropdownSearch 
                            placeholder={'Seleccione la serie'} 
                            returnSelectedOption={(data)=>{setDrone({...drone, serie: data})}} 
                            options={[...new Set(fetchedData.Drones.filter(item => item.linea === claimTicketData.tipo).map(item => item.serie))]}
                        />
                    </div>
                    
                    <div className="invisible-horizontal-container">
                        <div style={{fontWeight:'bold', minWidth: '150px'}}>Modelo:</div>
                        <DropdownSearch 
                            placeholder={'Seleccione el modelo'} 
                            keys={fetchedData.Drones.filter(item => item.serie == drone.serie && item.linea == claimTicketData.tipo).map(item => item.id)} 
                            returnSelectedKey={(data)=>{setDrone({...drone, objectid: data})}} 
                            options={fetchedData.Drones.filter(item => item.serie == drone.serie && item.linea == claimTicketData.tipo).map(item => item.modelo)}
                        />
                    </div>
                    
                    <div className="invisible-horizontal-container">
                        <div style={{fontWeight:'bold', minWidth: '150px'}}>Número de serie:</div>
                        <textarea 
                            className="textarea" 
                            rows={1} 
                            onChange={e => setDrone({ ...drone, no_serie: e.target.value })} 
                            placeholder="No. serie"
                        />
                    </div>
                    
                    <div className="invisible-horizontal-container">
                        <div style={{fontWeight:'bold', minWidth: '150px'}}>Observaciones del dron:</div>
                        <textarea 
                            className="textarea" 
                            rows={3} 
                            onChange={e => setDrone({ ...drone, observaciones: e.target.value })} 
                            placeholder="Observaciones del dron"
                        />
                    </div>
                    
                    <div className="invisible-horizontal-container">
                        <div style={{fontWeight:'bold', minWidth: '150px'}}>¿El dron ha sido reparado antes?:</div>
                        <Dropdown 
                            returnSelectedOption={(data)=>{setClaimTicketData(prev=>({...prev,reparadoAntes:data}))}} 
                            options={['No','Si, por SONAREX', 'Si, por tercero']}
                        />
                    </div>
                </div>
            ) : (
                <div className="item-container">Cargando información de drones...</div>
            )}
 
            <div className="header1">Batería</div>
            <div className="item-container">
              <div className="invisible-horizontal-container">
                <div style={{fontWeight:'bold', minWidth: '150px'}}>¿Incluye batería?:</div>
                <Dropdown 
                  returnSelectedOption={(data) => {
                    if (data === 'No') {
                      setBattery(false);
                    } else {
                      setBattery({
                        tipo: 'Bateria',
                        cantidad: 1,
                        observaciones: "",
                        custom_product_name: "",
                        extra: 0,
                        series: Array(1).fill("")
                      });
                    }
                  }} 
                  options={['No', 'Si']}
                />
              </div>
              
              {battery !== false && (
                <div>
                  <div className="invisible-horizontal-container">
                    <div style={{fontWeight:'bold', minWidth: '150px'}}>Modelo:</div>
                    <DropdownSearch 
                      placeholder={'Seleccione el modelo'} 
                      returnSelectedKey={key => setBattery({...battery, objectid: key})}
                      keys={fetchedData.Accesories.filter(item => item.tipo === 'Bateria').map(item => item.id)}
                      options={fetchedData.Accesories.filter(item => item.tipo === 'Bateria').map(item => item.modelo)}
                    />
                  </div>
                  
                  <div className="invisible-horizontal-container">
                    <div style={{fontWeight:'bold', minWidth: '150px'}}>Cantidad:</div>
                    <input
                      type="number"
                      min={1}
                      max={10}
                      value={battery.cantidad}
                      onChange={(e) => {
                        const value = parseInt(e.target.value) || 0;
                        if (value >= 1 && value <= 10) {
                          const newSeries = [...battery.series || []];
                          if (value > newSeries.length) {
                            while (newSeries.length < value) {
                              newSeries.push("");
                            }
                          } else if (value < newSeries.length) {
                            newSeries.length = value;
                          }
                          setBattery({
                            ...battery,
                            cantidad: value,
                            series: newSeries
                          });
                        }
                      }}
                    />
                  </div>

                  <div style={{fontWeight:'bold', marginTop: '15px', marginBottom: '5px'}}>Números de serie:</div>
                  <div className="series-fields">
                    {Array.from({ length: battery.cantidad }).map((_, index) => (
                      <div key={index} className="series-item">
                        <label>No. Serie Batería {index + 1}:</label>
                        <input
                          type="text"
                          className="series-input"
                          value={battery.series?.[index] || ""}
                          onChange={(e) => {
                            const newSeries = [...battery.series];
                            newSeries[index] = e.target.value;
                            setBattery({
                              ...battery,
                              series: newSeries
                            });
                          }}
                          placeholder={`Ingrese serie batería ${index + 1}`}
                        />
                      </div>
                    ))}
                  </div>

                  <div className="invisible-horizontal-container">
                    <div style={{fontWeight:'bold', minWidth: '150px'}}>Observaciones:</div>
                    <textarea 
                      className="textarea" 
                      rows={3} 
                      value={battery.observaciones}
                      onChange={e => setBattery({ ...battery, observaciones: e.target.value })} 
                      placeholder="Observaciones de las baterías"
                    />
                  </div>
                </div>
              )}
            </div>

           <div className="header1">Control</div>
            <div className="item-container">
              <div className="invisible-horizontal-container">
                <div style={{fontWeight:'bold', minWidth: '150px'}}>¿Incluye control?:</div>
                <Dropdown 
                  returnSelectedOption={(data) => {
                    if (data === 'No') {
                      setControl(false);
                    } else {
                      setControl({
                        tipo: 'Control',
                        cantidad: 1,
                        observaciones: "",
                        custom_product_name: "",
                        extra: 0,
                        series: Array(1).fill("")
                      });
                    }
                  }} 
                  options={['No', 'Si']}
                />
              </div>
              
              {control !== false && (
                <div>
                  <div className="invisible-horizontal-container">
                    <div style={{fontWeight:'bold', minWidth: '150px'}}>Modelo:</div>
                    <DropdownSearch 
                      placeholder={'Seleccione el modelo'} 
                      returnSelectedKey={key => setControl({...control, objectid: key})}
                      keys={fetchedData.Accesories.filter(item => item.tipo === 'Control').map(item => item.id)}
                      options={fetchedData.Accesories.filter(item => item.tipo === 'Control').map(item => item.modelo)}
                    />
                  </div>
                  
                  <div className="invisible-horizontal-container">
                    <div style={{fontWeight:'bold', minWidth: '150px'}}>Cantidad:</div>
                    <input
                      type="number"
                      min={1}
                      max={10}
                      value={control.cantidad}
                      onChange={(e) => {
                        const value = parseInt(e.target.value) || 0;
                        if (value >= 1 && value <= 10) {
                          const newSeries = [...control.series || []];
                          if (value > newSeries.length) {
                            while (newSeries.length < value) {
                              newSeries.push("");
                            }
                          } else if (value < newSeries.length) {
                            newSeries.length = value;
                          }
                          setControl({
                            ...control,
                            cantidad: value,
                            series: newSeries
                          });
                        }
                      }}
                    />
                  </div>

                  <div style={{fontWeight:'bold', marginTop: '15px', marginBottom: '5px'}}>Números de serie:</div>
                  <div className="series-fields">
                    {Array.from({ length: control.cantidad }).map((_, index) => (
                      <div key={`control-${index}`} className="series-item">
                        <label>No. Serie Control {index + 1}:</label>
                        <input
                          type="text"
                          className="series-input"
                          value={control.series?.[index] || ""}
                          onChange={(e) => {
                            const newSeries = [...control.series];
                            newSeries[index] = e.target.value;
                            setControl({
                              ...control,
                              series: newSeries
                            });
                          }}
                          placeholder={`Ingrese serie control ${index + 1}`}
                        />
                      </div>
                    ))}
                  </div>

                  <div className="invisible-horizontal-container">
                    <div style={{fontWeight:'bold', minWidth: '150px'}}>Observaciones:</div>
                    <textarea 
                      className="textarea" 
                      rows={3} 
                      value={control.observaciones}
                      onChange={e => setControl({ ...control, observaciones: e.target.value })} 
                      placeholder="Observaciones generales de los controles"
                    />
                  </div>
                </div>
              )}
            </div>
            <div className="header1">Par de hélices</div>
            <div className="item-container">
              <div className="invisible-horizontal-container">
                <div style={{fontWeight:'bold', minWidth: '150px'}}>¿Incluye hélices?:</div>
                <Dropdown 
                  returnSelectedOption={(data) => {
                    if (data === 'No') {
                      setPropellers(false);
                    } else {
                      setPropellers({
                        tipo: 'Helices',
                        cantidad: 1,
                        observaciones: "",
                        custom_product_name: "",
                        extra: 0,
                        no_serie: "",
                      });
                    }
                  }} 
                  options={['No', 'Si']}
                />
              </div>

              {propellers !== false && (
                <div>
                  <div className="invisible-horizontal-container">
                    <div style={{fontWeight:'bold', minWidth: '150px'}}>Modelo:</div>
                    <DropdownSearch 
                      placeholder={'Seleccione el modelo'} 
                      returnSelectedKey={(key) => setPropellers({ ...propellers, objectid: key })}
                      keys={fetchedData.Accesories.filter(item => item.tipo === 'Helices').map(item => item.id)}
                      options={fetchedData.Accesories.filter(item => item.tipo === 'Helices').map(item => item.modelo)}
                    />
                  </div>
                  
                  <div className="invisible-horizontal-container">
                    <div style={{fontWeight:'bold', minWidth: '150px'}}>Cantidad:</div>
                    <input
                      type="number"
                      min={1}
                      max={100}
                      value={propellers.cantidad}
                      onChange={(e) => {
                        const value = parseInt(e.target.value) || 1;
                        if (value >= 1 && value <= 100) {
                          setPropellers({ ...propellers, cantidad: value });
                        }
                      }}
                    />
                  </div>

                  <div className="invisible-horizontal-container">
                    <div style={{fontWeight:'bold', minWidth: '150px'}}>Observaciones:</div>
                    <textarea 
                      className="textarea" 
                      rows={3} 
                      value={propellers.observaciones}
                      onChange={(e) => setPropellers({ ...propellers, observaciones: e.target.value })}
                      placeholder="Observaciones generales de las hélices"
                    />
                  </div>
                </div>
              )}
            </div>

               
            <div className="header1">Items extra</div>
            <div className="item-container">
              <div className="invisible-horizontal-container">
                <Button color={"#61BAA5"} text={"Agregar item extra"} 
                  onClick={() => {
                    setExtraItems([...extraItems,{cantidad:1,observaciones:"",custom_product_name:"",no_serie:"",extra:1}])
                  }}
                />
              </div>
              
              { extraItems.map((_, i) => (
                <div className="series-item" key={i} index={i} style={{marginTop: '15px', paddingTop: '15px', borderTop: '1px solid #ddd'}}> 
                  <div className="invisible-horizontal-container">
                    <div style={{fontWeight:'bold', minWidth: '150px'}}>Tipo de item:</div>
                    <Dropdown placeholder={'Seleccione el tipo de item'} options={['Parte', 'Accesorio']} returnSelectedOption={(data)=>{
                      setExtraItems(prevItems =>
                        prevItems.map((item, j) =>
                          j === i ? { ...item, searchType: data} : item
                        )
                      );
                    }}></Dropdown>
                  </div>
                  
                  {extraItems[i].searchType && (
                    <div>
                      <div className="invisible-horizontal-container">
                        <div style={{fontWeight:'bold', minWidth: '150px'}}>Tipo de {extraItems[i].searchType}:</div>
                        <DropdownSearch placeholder={'Seleccione el tipo de ' + extraItems[i].searchType} returnSelectedOption={(data)=>{
                          setExtraItems(prevItems =>
                            prevItems.map((item, j) =>
                              j === i ? { ...item, tipo: data} : item
                            ))
                        }} options={
                          [...new Set(extraItems[i].searchType === 'Parte'
                            ? fetchedData.Parts.map(item => item.tipo)
                            : fetchedData.Accesories.map(item => item.tipo))]}></DropdownSearch>
                      </div>

                      <div className="invisible-horizontal-container">
                        <div style={{fontWeight:'bold', minWidth: '150px'}}>Modelo:</div>
                        <DropdownSearch placeholder={'Seleccione el modelo '} returnSelectedKey={(data)=>{
                          setExtraItems(prevItems =>
                            prevItems.map((item, j) =>
                              j === i ? { ...item, objectid: data} : item
                            ))
                        }} keys={
                          extraItems[i].searchType === 'Parte'
                            ? fetchedData.Parts.filter(item => item.tipo === extraItems[i].tipo).map(item => item.id)
                            : fetchedData.Accesories.filter(item => item.tipo === extraItems[i].tipo).map(item => item.id)}
                        options={
                          extraItems[i].searchType === 'Parte'
                            ? fetchedData.Parts.filter(item => item.tipo === extraItems[i].tipo).map(item => item.modelo)
                            : fetchedData.Accesories.filter(item => item.tipo === extraItems[i].tipo).map(item => item.modelo)}></DropdownSearch>
                      </div>

                      <div className="invisible-horizontal-container">
                        <div style={{fontWeight:'bold', minWidth: '150px'}}>Cantidad:</div>
                        <input
                          type="number"
                          min={1}
                          defaultValue={1}
                          max={100}
                          onChange={(data) => {
                            const value = data.target.value;
                            if (value.length <= 3 && /^\d*$/.test(value)) {
                              const numericValue = parseInt(value, 10);
                              if (!isNaN(numericValue) && numericValue >= 1 && numericValue <= 100) {
                                setExtraItems(prevItems =>
                                  prevItems.map((item, j) =>
                                    j === i ? { ...item, cantidad: numericValue} : item
                                  ))
                              } else if (value === '') {
                                setExtraItems(prevItems =>
                                  prevItems.map((item, j) =>
                                    j === i ? { ...item, cantidad: 0} : item
                                  ))
                              }}
                            }}
                        />
                      </div>
                      
                      {extraItems[i].tipo !== 'Helices' && (
                        <div className="invisible-horizontal-container">
                          <div style={{fontWeight:'bold', minWidth: '150px'}}>Número de serie:</div>
                          <textarea
                            className="textarea"
                            rows={1}
                            onChange={e => {
                              setExtraItems(prevItems =>
                                prevItems.map((item, j) =>
                                  j === i ? { ...item, no_serie: e.target.value } : item
                                )
                              );
                            }}
                            placeholder="No. serie"
                          />
                        </div>
                      )}

                      <div className="invisible-horizontal-container">
                        <div style={{fontWeight:'bold', minWidth: '150px'}}>Observaciones:</div>
                        <textarea 
                          className="textarea" 
                          rows={3} 
                          onChange={e=>{
                            setExtraItems(prevItems =>
                              prevItems.map((item, j) =>
                                j === i ? { ...item, observaciones: e.target.value} : item
                              ))
                          }} 
                          placeholder="Observaciones"
                        />
                      </div>
                      
                      <div className="invisible-horizontal-container right-justified">
                        <Button 
                          color={"#ff6b6b"} 
                          text={"Eliminar"} 
                          onClick={() => {
                            setExtraItems(prevItems => prevItems.filter((_, j) => j !== i));
                          }}
                        />
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
            <div className="item-container" style={{marginTop: '20px'}}>
              <div className="invisible-horizontal-container">
                <div style={{fontWeight:'bold', fontSize: '16px', color: '#555'}}>Todos los campos marcados son obligatorios para generar la nota de recepción.</div>
              </div>
              <div className="justify-right">
                <Button 
                  onClick={()=>{
                    if (claimTicketData.cliente === 0) {
                      alert('Seleccione un cliente a quien vincular la nota primero');
                      return;
                    }

                    if (!claimTicketData.causa || claimTicketData.causa.trim() === '') {
                      alert('Seleccione o escriba la causa de la nota');
                      return;
                    }

                    const missingFields = [];

                    if (drone && !drone.objectid) {
                      missingFields.push('modelo de dron');
                    }

                    if (battery && !battery.objectid) {
                      missingFields.push('modelo de batería');
                    }

                    if (control && !control.objectid) {
                      missingFields.push('modelo de control');
                    }

                    if (propellers && !propellers.objectid) {
                      missingFields.push('modelo de hélices');
                    }

                    extraItems.forEach(item => {
                      if (!item.objectid || !item.cantidad || !item.searchType) {
                        missingFields.push(`un accesorio extra sin información completa`);
                      }
                    });

                    if (missingFields.length > 0) {
                      alert('Faltan los siguientes campos:\n- ' + missingFields.join('\n- '));
                      return;
                    }

                    // ✅ Everything is valid — proceed with posting
                    postData(API_URLS.CLAIM_TICKETS, claimTicketData, (data) => {
                      console.log("Datos de la nota creada:", data);
                      console.log("Cliente ID en claimTicketData:", claimTicketData.cliente, "tipo:", typeof claimTicketData.cliente);
                      
                      if (drone && drone.objectid) {
                        postData(API_URLS.CLAIMOBJECT, { ...drone, NotasRecepcion_folio: data.id });
                      }

                      const batteryItems = prepareBatteryData();
                        batteryItems.forEach(batteryItem => {
                          postData(API_URLS.CLAIMOBJECT, {
                            ...batteryItem,
                            NotasRecepcion_folio: data.id
                          });
                        });


                        const controlItems = prepareControlData();
                        controlItems.forEach(controlItem => {
                          postData(API_URLS.CLAIMOBJECT, {
                            ...controlItem,
                            NotasRecepcion_folio: data.id
                          });
                        });


                      if (propellers && propellers.objectid) {
                        postData(API_URLS.CLAIMOBJECT, { ...propellers, tipo: 'Accesorio', NotasRecepcion_folio: data.id });
                      }

                      extraItems.forEach(item => {
                        if (item.searchType && item.objectid && item.cantidad) {
                          postData(API_URLS.CLAIMOBJECT, { ...item, tipo: item.searchType, NotasRecepcion_folio: data.id });
                        }
                      });
                      console.log("Llamando a downloadNotePDF con clienteID:", claimTicketData.cliente, "tipo:", typeof claimTicketData.cliente);
                      downloadNotePDF(
                            data.id,
                            claimTicketData.fecha,
                            claimTicketData.cliente,
                            claimTicketData.sucursal
                          );      
                          onAccept(); // Cerrar el popup
                        });
                }} 
                  color={"#61BAA5"} 
                  text={"Generar nota de recepción"} 
                  style={{padding: '10px 20px', fontSize: '16px'}}
                />
              </div>
            </div>
        </Popup>
    )
}

export default NewClaimTicket;